import { RootState } from "@/modules/common";

export const selectUser = ({ auth }: RootState) => auth.user;
